import { PsrSection } from './PsrSection';
import NsContent from 'components/common/ns-content/NsContent';
import type { PsrType } from 'components/direct-sales/psr-capture/psr-types';

export const testId = 'psrListTestId';

type PsrListProps = {
  psr?: PsrType[];
};

export const PsrList = ({ psr = [] }: PsrListProps) => {
  return (
    <div data-testid={testId}>
      <NsContent>
        {psr.map((psrSection) => (
          <PsrSection key={psrSection.code} psrSection={psrSection} />
        ))}
      </NsContent>
    </div>
  );
};
